<template>
  <div
    class="library-gallery"
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
  >
    <h3 class="container gallery-ttl font-38">
      {{ _.get(contentData, `conf.header.title`) }}
    </h3>
    <swiper
      ref="libraryGallery"
      class="gallerySwiper libraryGallery gallery-list grab"
      :options="swiperOptions"
    >
      <swiper-slide
        v-for="(image, index) in _.get(
          contentData,
          'data.list[0].additional_images'
        )"
        :class="
          selectedId !== image.id && selectedId === 'all'
            ? 'active-hover'
            : selectedId === image.id
            ? 'not-active'
            : 'fade-opacity'
        "
        :key="image.id"
      >
        <div
          class="image-cont"
          @mouseenter="
            $mq !== 'phone' && $mq !== 'tablet'
              ? !touchMove
                ? (selectedId = image.id)
                : ''
              : ''
          "
          @mouseleave="
            $mq !== 'phone' && $mq !== 'tablet'
              ? !touchMove
                ? (selectedId = 'all')
                : ''
              : ''
          "
        >
          <picture>
            <source media="(max-width: 767px)" :srcset="image.devices.mobile" />
            <source
              media="(max-width: 1023px)"
              :srcset="image.devices.tablet"
            />
            <img :src="image.devices.desktop" alt />
          </picture>
          <div class="hover-symbol" @click="activeSwiper(index)">
            <light-gallery-symbol />
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <gallery-popup
      @close="close"
      :images="_.get(contentData, 'data.list[0].additional_images')"
      :imageId="selectedImage"
      :clickedIndex="clickedIndex"
    />
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import LightGallerySymbol from "@/components/LightGallerySymbol";

import ShareSocial from "@/components/ShareSocial";
import OfferTypeButton from "@/components/SearcWithTags/TypeButton";
import GalleryPopup from "../Popups/GalleryPopup.vue";

export default {
  name: "library-gallery",
  components: {
    LightGallerySymbol,
    Breadcrumbs,

    ShareSocial,
    OfferTypeButton,
    GalleryPopup
  },
  props: ["contentData", "evenOdd"],
  data() {
    const _this = this;
    return {
      swiperOptions: {
        speed: 800,

        breakpoints: {
          320: {
            slidesPerView: 1.2
          },
          1024: {
            slidesPerView: 2.2
          }
        },
        on: {
          touchMove() {
            _this.touchMove = true;
            document
              .querySelectorAll(".library-gallery .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(0.75, 0.75)";
              });
          },
          touchEnd() {
            _this.touchMove = false;
            document
              .querySelectorAll(".library-gallery .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(1, 1)";
              });
          }
        }
      },

      selectedId: "all",
      selectedImage: null,
      clickedIndex: 0,
      touchMove: false
    };
  },
  watch: {
    selectedImage(val) {
      if (val) {
        let root = document.getElementsByTagName("html")[0]; // '0' to assign the first (and only `HTML` tag)

        root.setAttribute("class", "hide-scroll");
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.libraryGallery.$swiper;
    }
  },
  methods: {
    activeSwiper(index) {
      this.clickedIndex = index;
      this.selectedImage = true;
    },
    close() {
      this.selectedImage = false;
      this.clickedIndex = 0;
    }
  }
};
</script>

<style scoped>
.library-gallery {
  padding-top: 55px;
}
.gallery-ttl {
  margin-bottom: 45px;
}
.swiper-scrollbar {
  background-color: #dadada;
  height: 3px !important;
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
}
body[data-theme="night"] .swiper-scrollbar {
  background-color: #555555;
}
.swiper-scrollbar-drag {
  top: -1px;
  background: linear-gradient(
    to right,
    #26dffe 0%,
    #21cdf5 30%,
    #0dbff4 75%,
    #00aeef 100%
  );
  height: 5px;
  cursor: pointer;
}
.image-cont {
  position: relative;
  height: 610px;
  transition: opacity 0.6s;
}
.image-cont img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.8;
}
@media (min-width: 768px) {
  .image-cont .hover-symbol {
    opacity: 0;
    visibility: hidden;
  }
  .image-cont:hover .hover-symbol {
    opacity: 1;
    visibility: visible;
  }
}
.image-cont .hover-symbol {
  opacity: 1;
  visibility: visible;
}
.hover-symbol {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  right: 60px;
  bottom: 66px;
  transition: 0.6s;
}

.gallery-list {
  transition: 0.6s ease;
}
.gallerySwiper {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.gallerySwiper:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.gallery-swiper-nav .nav--next {
  left: 5%;
}
.gallery-swiper-nav .nav--next svg {
  transform: rotate(180deg);
}

.gallery-swiper-close {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  width: 36px;
  height: 36px;
  z-index: 99999;
  right: 5%;
  top: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #dadada;
  cursor: pointer;
  transition: 0.3s;
}
.gallery-swiper-nav .nav-item {
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  position: absolute;
  transform: translate(50%, -50%);
  z-index: 99999;
  top: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #dadada;
  cursor: pointer;
}
.gallery-swiper-nav .nav--prev {
  right: 6%;
}
.gallerySwiper.gallery-list-popup.activated + .gallery-swiper-nav .nav-item {
  opacity: 1;
  visibility: visible;
}
.gallerySwiper.gallery-list-popup.activated .image-cont img {
  object-fit: contain;
}
@media (max-width: 1025px) {
  .gallery-swiper-close {
    position: fixed;
    top: 10%;
  }
  .gallery-swiper-nav .nav-item {
    position: fixed;
    transform: translate(20%, -50%);
  }
}
@media (max-width: 1023px) {
  .gallery-ttl.font-38 {
    margin-bottom: 30px;
    font-size: 28px;
  }
}
@media (max-width: 767px) {
  .gallery-swiper-nav .nav--next {
    left: 10px;
  }
  .gallery-swiper-nav .nav--prev {
    right: 25px;
  }
  .hover-symbol {
    bottom: 20px;
    right: 20px;
  }
}
</style>
